import { useContext } from 'react'
import {
  type ArchiveOrDeferFn,
  InboxDeferredArchiveContext,
} from '#src/contexts/InboxDeferredArchiveContext.ts'

/*
 * Returns the inbox archive-or-defer fn, or null when not inside the inbox
 * provider (e.g. Tasks page / chart), in which case callers archive immediately.
 */
export function useInboxDeferredArchive(): ArchiveOrDeferFn | null {
  return useContext(InboxDeferredArchiveContext)
}
